<template>
  <assigned-component>
    <b-row class="mt-2 mb-2">             
      <b-col md="4" class="my-1 ">
        <b-form-group label-cols-sm="3" label="Search" class="mb-0">
          <b-input-group>
            <b-form-input v-model="filter" placeholder="Type to Search"></b-form-input>
            <b-input-group-append>
              <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
            </b-input-group-append>
          </b-input-group>
        </b-form-group>
      </b-col>
      <b-col md="4" class="my-1">
        <b-form-group label-cols-sm="3" label="Sort" class="mb-0">
          <b-input-group>
            <b-form-select v-model="sortBy" :options="sortOptions">
              <option slot="first" :value="null">-- none --</option>
            </b-form-select>
            <b-form-select v-model="sortDesc" :disabled="!sortBy" slot="append">
              <option :value="false">Asc</option> <option :value="true">Desc</option>
            </b-form-select>
          </b-input-group>
        </b-form-group>
      </b-col>             
      <b-col md="4" class="my-1">
        <!-- <b-form-group label-cols-sm="3" label="Per page" class="mb-0">
          <b-form-select v-model="perPage" :options="pageOptions"></b-form-select>
        </b-form-group> -->
      </b-col>            
    </b-row> 
    <b-row>
      <b-col sm="12" class="text-right">
               <p > <b>Total Records :<span style="color:red;">{{ this.totalRows }}</span></b> </p>
              </b-col> 
      <b-table show-empty stacked="md"  :items="items"  :fields="fields"  :current-page="currentPage"  :per-page="perPage"  :filter="filter"   :sort-by.sync="sortBy"  :sort-desc.sync="sortDesc"   :sort-direction="sortDirection"    @filtered="onFiltered"    :outlined="outlined" :busy="isBusy" >
           <template slot="shippingid" slot-scope="row">
          {{ row.item.shippingid}}
         <span class="badge badge-primary badge-pill" v-if="row.item.orderflow=='Reverse'">{{ row.item.orderflow}}</span>
         <span class="badge badge-primary badge-pill"  v-if="row.item.istrybuy=='1' && row.item.orderflow !='Reverse'">istrybuy</span>
         </template>
          <template slot="userinfo" slot-scope="row">
                 {{ row.item.deliveryagentfirstname}} {{ row.item.deliveryagentlastname}}
          </template> 
          <template slot="actions" slot-scope="row">
              <b-button size="sm" @click="info(row.item, row.index, $event.target)" class="mr-1">
                      View
              </b-button>
          </template>
          <div slot="table-busy" class="text-center text-danger my-2">
            <b-spinner class="align-middle"></b-spinner>
            <strong>Loading...</strong>
          </div>     
      </b-table> 
      <b-col md="6" class="my-1" v-if="this.totalRows > 10">
        <b-pagination
              v-model="currentPage"
              :total-rows="totalRows"
              :per-page="perPage"
              class="my-0"
            ></b-pagination>
      </b-col> 
    </b-row>  
    <b-modal :id="infoModal.id" :title="infoModal.title" ok-only @hide="resetInfoModal">
      <template slot="default" slot-scope="{ hide }">
        <div v-if="infoModal.content.length > 0">
          <div class="card">        
            <div class="card-body">
               <div class="row">
                <div class="col-sm-12 col-lg-12">
                 <div class="row">
                    <div class="col-sm-6">
                       <div class="callout callout-info">
                          <strong class="text-muted">Shipping Id</strong><br><strong class="h4">{{ infoModal.data.shippingid }}</strong>
                         
                       </div>
                    </div>
                    <div class="col-sm-6">
                       <div class="callout callout-danger">
                          <strong class="text-muted">Consignmentmaster id</strong><br><strong class="h4 ">{{ infoModal.data.consignmentmasterid }}</strong>               
                       </div>
                    </div>
                 </div>
                  <hr class="mt-0"><br>
                  <div class="progress-group mb-4">
                    <div class="progress-group-prepend"><strong class="progress-group-text">
                       Shipment Status:
                       </strong>
                    </div>
                    <div class="progress-group-bars pull-right">
                      {{ infoModal.data.shipmentstatus }}               
                    </div>
                  </div>
                  <hr class="mt-0">
                  <div class="progress-group mb-4">
                    <div class="progress-group-prepend"><strong class="progress-group-text">
                       Shipping code:
                       </strong>
                    </div>
                    <div class="progress-group-bars">
                      {{ infoModal.data.shippincode }}               
                    </div>
                  </div>
                  <hr class="mt-0"> 
                  <div class="progress-group mb-4">
                    <div class="progress-group-prepend"><strong class="progress-group-text">
                       Delivery Status:
                       </strong>
                    </div>
                    <div class="progress-group-bars">
                      {{ infoModal.data.deliverystatus }}               
                    </div>
                  </div> 
                  <hr class="mt-0">
                  <div class="progress-group mb-4">
                    <div class="progress-group-prepend"><strong class="progress-group-text">
                       Ship address: 
                       </strong>
                    </div>
                    <div class="progress-group-bars">
                      {{ infoModal.data.shipaddress1 }}               
                    </div>
                  </div> 
                  <hr class="mt-0">
                  <div class="progress-group mb-4">
                    <div class="progress-group-prepend"><strong class="progress-group-text">
                       Order Flow:
                       </strong>
                    </div>
                    <div class="progress-group-bars">
                      {{ infoModal.data.orderflow }}               
                    </div>
                  </div> 
                  <hr class="mt-0">
                  <div class="progress-group mb-4">
                    <div class="progress-group-prepend"><strong class="progress-group-text">
                       Deliveryagent Name:
                       </strong>
                    </div>
                    <div class="progress-group-bars">
                      {{ (infoModal.data.deliveryagentfirstname) }}  {{ (infoModal.data.deliveryagentlastname)?infoModal.data.deliveryagentlastname:'-' }}              
                    </div>
                  </div> 
                 
                  <hr class="mt-0"> 
                  <div class="progress-group mb-4">
                    <div class="progress-group-prepend"><strong class="progress-group-text">
                       Deliveryagent Mobilenumber:
                       </strong>
                    </div>
                    <div class="progress-group-bars">
                      {{ (infoModal.data.deliveryagentmobilenumber)?infoModal.data.deliveryagentmobilenumber:'-' }}               
                    </div>
                  </div> 
                  <hr class="mt-0">
                  <div class="progress-group mb-4">
                    <div class="progress-group-prepend"><strong class="progress-group-text">
                       Pickuplocation Address:
                       </strong>
                    </div>
                    <div class="progress-group-bars">
                      {{ (infoModal.data.pickuplocationaddress)?infoModal.data.pickuplocationaddress:'-' }}               
                    </div>
                  </div>

                  <hr class="mt-0">
                  <div class="progress-group mb-4">
                    <div class="progress-group-prepend"><strong class="progress-group-text">
                      Manual Allocation:
                       </strong>
                    </div>
                    <div class="progress-group-bars">
                      {{ (infoModal.data.manualallocation)?infoModal.data.manualallocation:'-' }}               
                    </div>
                  </div>

                  <hr class="mt-0">
                  <div class="progress-group mb-4">
                    <div class="progress-group-prepend"><strong class="progress-group-text">
                       Delivery Instructions:
                       </strong>
                    </div>
                    <div class="progress-group-bars">
                      {{ (infoModal.data.deliveryinstructions)?infoModal.data.deliveryinstructions:'-' }}               
                    </div>
                  </div>

                </div>   
               </div>
            </div>
          </div>  
        </div>

      </template>
      <template slot="modal-footer" slot-scope="{ cancel }">
        <b-button size="sm" variant="danger" @click="cancel()" style="display:none">
          Cancel
        </b-button>
      </template>

    </b-modal>
  </assigned-component>
</template>
<script>
import CONSTANTS from '@/utils/constants'
import Utils from '@/utils'
import auth from '@/utils/auth'

export default {
  data: function() {
    return {
      assigned:[],
      items:[],
      isBusy: false,
      fields: [
          { key: 'shippingid', label: 'AWB', sortable: true, sortDirection: 'desc' },
          { key: 'pickuplocationaddress', label: 'Pickup Address', sortable: true},
          { key: 'shipaddress1', label: 'Delivery Address', sortable: true},
          { key: 'userinfo', label: 'SR Name', sortable: true},
          { key: 'deliveryagentmobilenumber', label: 'Mobile Number', sortable: true},               
          { key: 'lastmodifieddate', label: 'Date', sortable: true },
          { key: 'manualallocation', label: 'allocation', sortable: true },
          { key: 'actions', label: 'Actions' },
      ],
      outlined: true,
      totalRows: 0,
      currentPage: 1,
      perPage:  10,
      pageOptions: [5, 10, 15],
      sortBy: null,
      sortDesc: false,
      sortDirection: 'asc',
      filter: null,
      infoModal: {
          id: 'info-modal',
          title: '',
          content: '',
          data:''
      }
    }
  },
   computed: {
      sortOptions() {
        // Create an options list from our fields
        return this.fields
          .filter(f => f.sortable)
          .map(f => {
            return { text: f.label, value: f.key }
          })
      }
    },
  created: function() {
    this.getAssignedShipment()
  },
  mounted () {},
  methods: {
      info(item, index, button) {
        this.infoModal.content = JSON.stringify(item, null, 2);
        //JSON.parse(JSON.stringify(item, null, 2))
        this.infoModal.data = item;
        this.infoModal.title = 'Pick Cancel';
        this.$root.$emit('bv::show::modal', this.infoModal.id, button)
      },
      resetInfoModal() {
        this.infoModal.title = '',
        this.infoModal.content = '',
        this.infoModal.data = ''
      },
      onFiltered(filteredItems) {
        // Trigger pagination to update the number of buttons/pages due to filtering
        this.totalRows = filteredItems.length
        this.currentPage = 1
      },
    getAssignedShipment(){
      this.isBusy = true;
      let userData = localStorage.getItem('userData');
      let userInfo = JSON.parse(userData);
      let pincode=JSON.stringify(userInfo.pickuplocationpincode);
      let obj = {
        pickuplocationpincode: pincode,
        status: "BookingPending"
      }
      this.$http
          .post(
            `${CONSTANTS.API_URL}/P2PReports/GetStatuswiseList`,obj)
          .then(result => {
            // console.log(result.body);
              this.isBusy = !this.isBusy;
              if(result.body.returnmsg === "successful"){
                // console.log("result.body.returnvalue",result.body.returnvalue);
               // this.assigned = result.body.returnvalue;
                //this.items  = result.body.returnvalue;
               // this.totalRows = result.body.returnvalue.length

                var results=[];
                results =result.body.returnvalue;
                var searchResults=[];
                results.forEach((element) => {             
                  if(element.deliverystatus.toLowerCase()=='pickcancel'){
                    searchResults.push(element);
                  }
                });        
                this.items  = searchResults;
                this.totalRows = searchResults.length;

              }else {
               this.items  = [];
               this.totalRows = 0
              }
          }).catch(ex => {
            console.log('error', ex)
          })
    }
  }
}
</script>
